import { render } from "./Index.vue?vue&type=template&id=47c388e0&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=47c388e0&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=47c388e0&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c388e0"]])

export default __exports__